export const MemberStatesMapping = [
        {
            state: "Interested",
            stateString: "Interesado",
            buttons: [
                { icon: "cancel", title: "Rechazar" },
                { icon: "forward_to_inbox", title: "Reenviar" }
            ],
            cssClass: "interesado"
        },
        {
            state: "Pending",
            stateString: "Pendiente",
            buttons: [
                { icon: "cancel", title: "Rechazar" },
                { icon: "how_to_reg", title: "Habilitar" }
            ],
            cssClass: "pendiente"
        },
        {
            state: "NearFromExpire",
            stateString: "Por Vencer",
            buttons: [
                //{ icon: "autorenew", title: "Renovar" },
                { icon: "lock", title: "Inhabilitar" }
            ],
            cssClass: "porVencer"
        },
        {
            state: "Active",
            stateString: "Activo",
            buttons: [
                { icon: "lock", title: "Inhabilitar" }
            ],
            cssClass: "activo"
        },
        {
            state: "Rejected",
            stateString: "Rechazado",
            buttons: [
                { icon: "how_to_reg", title: "Habilitar" }
            ],
            cssClass: "rechazado"
        },
        {
            state: "Expired",
            stateString: "Vencido",
            buttons: [
                //{ icon: "how_to_reg", title: "Habilitar" }
            ],
            cssClass: "vencido"
        },
        {
            state: "Locked",
            stateString: "Bloqueado",
            buttons: [
                { icon: "lock_open", title: "Desbloquear" }
            ],
            cssClass: "bloqueado"
        },
        {
            state: "Disabled",
            stateString: "Deshabilitado",
            buttons: [
                { icon: "lock_open", title: "Desbloquear" }
            ],
            cssClass: "bloqueado"
        }
    ]